// extracted by mini-css-extract-plugin
module.exports = {"entering":"transition-slideDown-module--entering--3LRPf","entered":"transition-slideDown-module--entered--2jxog","exiting":"transition-slideDown-module--exiting--1z1Ma"};